import src from "IMAGE";
export default { src, width: 231, height: 284, blurWidth: 0, blurHeight: 0};
